module.exports = __webpack_public_path__ + "img/qer.a72dd706.png";